import { gql } from '@apollo/client';

import { CORE_USER_SETTINGS, CORE_COLLECT_OVERVIEW_FIELDS } from '../fragments';

export const COLLECT_OVERVIEWS = gql`
  ${CORE_COLLECT_OVERVIEW_FIELDS}
  query CollectOverviews($year: Int!, $categoryLevel: EsgCategoryLevel) {
    collectOverviews(year: $year, categoryLevel: $categoryLevel) {
      ...CoreCollectOverviewFields
    }
  }
`;

export const COLLECT_OVERVIEW_BY_ID = gql`
  ${CORE_COLLECT_OVERVIEW_FIELDS}
  query CollectOverviewById($id: ID!) {
    collectOverviewById(id: $id) {
      ...CoreCollectOverviewFields
    }
  }
`;

export const REMINDER = gql`
  query Reminder($input: ReminderInput!) {
    reminder(input: $input) {
      collectOverviewId
      createDate
      executionDate
      id
      status
      recipientId
    }
  }
`;

export const USER_SETTINGS = gql`
  ${CORE_USER_SETTINGS}
  query UserSettings {
    userSettings {
      ...CoreUserSettings
    }
  }
`;

export const COLLECT_OVERVIEW_YEARS_BY_EXTERNAL_USER = gql`
  query CollectYearsByExternal {
    collectYearsByExternal
  }
`;
